export const OPERATOR_SYMBOL_MAPPING = {
  contains: '∋',
  equals: '=',
  '=': '=',
  '!=': '≠',
  '>': '>',
  '>=': '≥',
  '<': '<',
  '<=': '≤',
  startsWith: '⊃',
  endsWith: '⊂',
  is: '=',
  not: '≠',
  isNot: '≠',
  isEmpty: '∅',
  isNotEmpty: '∉',
  isIn: '∈',
  isNotIn: '∉',
  isLessThan: '<',
  isLessThanOrEqual: '≤',
  isGreaterThan: '>',
  isGreaterThanOrEqual: '≥',
  isBetween: '∈',
  isNotBetween: '∉',
  isAnyOf: '∈',
  after: '>',
  onOrAfter: '≥',
  before: '<',
  onOrBefore: '≤'
};